// Copyright 2022 - 2023 Fewcha. All rights reserved.

import { createAsyncThunk, createReducer } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { web3 } from "services/web3";
import { defaultTokensReducer } from "./types";

export const getTokens = createAsyncThunk("tokens/getTokens", async () => {
  const data = await (web3.action.aptos as any).getTokens();

  if (data.status === 200) {
    return data.data;
  }
  return [];
});

const tokensReducer = createReducer(defaultTokensReducer, (builder) =>
  builder
    .addCase(getTokens.pending, (state) => {
      state.loading = true;
    })
    .addCase(getTokens.rejected, (state) => {
      state.loading = false;
    })
    .addCase(getTokens.fulfilled, (state, action) => {
      state.loading = false;
      state.tokens = action.payload;
    }),
);

export const selectTokens = (state: RootState) => state.tokens;

export default tokensReducer;
